import React from 'react';
import imagenFondo from '../assets/logo_elecnor.jpg';
import PermisoEscalera from './PermisoEscalera';
import PermisoPlataforma from './PermisoPlataforma';
import BloqueoElectrico from './BloqueoElectrico';   
import DescargoElectrico from './DescargoElectrico';

const HptPdfTemplate = React.forwardRef(({ hpt, seguimiento, catalogo, opcionesPdf }, ref) => {
    if (!hpt || !opcionesPdf) return null;

    

    // Función Firmar
    const renderFirma = (rol, titulo) => {
        const firma = seguimiento?.find(s => s.rol === rol && s.firmado);
        return (
            <td style={{ border: '1px solid #003366', width: '16.6%', verticalAlign: 'top', padding: '4px', backgroundColor: '#fff' }}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '120px', justifyContent: 'space-between' }}>
                    {firma ? (
                        <>
                            <div style={{ fontSize: '8px', textAlign: 'left', color: '#333' }}>
                                <strong>{firma.fecha}</strong><br/>
                                {firma.usuario || 'Firmado digitalmente'}
                            </div>
                            <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {firma.firma_base64 && (
                                    <img src={firma.firma_base64} alt="Firma" style={{ maxHeight: '55px', maxWidth: '95%', objectFit: 'contain' }} />
                                )}
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={{ fontSize: '8px', color: '#999' }}>Pendiente de firma</div>
                            <div style={{ flexGrow: 1 }}></div>
                        </>
                    )}
                    <div style={{ fontSize: '8px', fontWeight: 'bold', textAlign: 'center', borderTop: '1px solid #ccc', paddingTop: '4px' }}>
                        {titulo}
                    </div>
                </div>
            </td>
        );
    };

    return (
        <div ref={ref} style={styles.page}>
            {/* --- 1 AL 5. BLOQUE BASE DE LA HPT --- */}
        {opcionesPdf.base && (
            <>
                {/* CABECERA ESTILO ISO / CALIDAD */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '15px' }}>
                    <tbody>
                        <tr>
                            {/* 1. LOGO (Ocupa 3 filas) */}
                            <td rowSpan="3" style={{ width: '25%', border: '1px solid #003366', textAlign: 'center', verticalAlign: 'middle', padding: '10px' }}>
                                <img src={imagenFondo} alt="Logo" style={{ maxHeight: '50px' }} /> 
                            </td>

                            {/* 2. TÍTULO CENTRAL (Ocupa 3 filas) */}
                            <td rowSpan="3" style={{ width: '50%', border: '1px solid #003366', textAlign: 'center', verticalAlign: 'middle', padding: '10px' }}>
                                <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#003366', fontFamily: 'Arial, sans-serif' }}>
                                    HOJA PLANIFICACIÓN PREPARACIÓN<br/>TRABAJOS ASTES
                                </div>
                            </td>

                            {/* 3. CÓDIGO (Fila 1 de 3) */}
                            <td style={{ width: '25%', border: '1px solid #003366', textAlign: 'center', verticalAlign: 'middle', padding: '4px', backgroundColor: '#fff' }}>
                                <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#003366' }}>
                                    FI.TER.AXT.08.02
                                </div>
                            </td>
                        </tr>
                        <tr>
                            {/* 4. REVISIÓN (Fila 2 de 3) */}
                            <td style={{ border: '1px solid #003366', textAlign: 'center', verticalAlign: 'middle', padding: '4px', backgroundColor: '#fff' }}>
                                <div style={{ fontSize: '10px', color: '#003366' }}>
                                    Revisión 08
                                </div>
                            </td>
                        </tr>
                        <tr>
                            {/* 5. FECHA (Fila 3 de 3) */}
                            <td style={{ border: '1px solid #003366', textAlign: 'center', verticalAlign: 'middle', padding: '4px', backgroundColor: '#fff' }}>
                                <div style={{ fontSize: '10px', color: '#003366' }}>
                                    Fecha: 18/05/23
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* --- 2. BLOQUE DE FIRMAS Y DATOS TÉCNICOS --- */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '10px' }}>
                    <thead>
                        <tr>
                            <th colSpan="2" style={{ ...styles.thISO, padding: '6px', fontSize: '11px' }}>
                                PLANIFICACION
                            </th>
                            <th colSpan="4" style={{...styles.thISO, padding: '6px', fontSize: '11px' }}>
                                REVISADO Y VISTO BUENO
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {/* Celda 1: Solicitante */}
                            {renderFirma('SOLICITANTE', 'FDO. JEFE DE TRABAJO O ENCARGADO POR AUSENCIA')}
                            
                            {/* Celda 2: Subcontrata */}
                            {renderFirma('RESP_SUBCONTRATA', 'FDO. RESPONSABLE DE SUBCONTRATA (SOLO SI APLICA)')}
                            
                            {/* Celda 3: Datos de Duración/Operarios */}
                            <td style={{ border: '1px solid #003366', width: '16.6%', verticalAlign: 'middle', padding: '8px', textAlign: 'center', backgroundColor: '#fff' }}>
                                <div style={{ marginBottom: '15px' }}>
                                    <strong style={{ fontSize: '9px', color: '#003366' }}>Duración del trabajo prevista en horas:</strong><br/>
                                    <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{hpt.duracion_prevista_hours}</span>
                                </div>
                                <div>
                                    <strong style={{ fontSize: '9px', color: '#003366' }}>Nº operarios previstos:</strong><br/>
                                    <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{hpt.operarios_previstos}</span>
                                </div>
                            </td>

                            {/* Celda 4: Prevención */}
                            {renderFirma('PREVENCION', 'FDO. PRL')}

                            {/* Celda 5: Supervisor */}
                            {renderFirma('SUPERVISOR', 'FDO. SOLICITANTE / SUPERVISOR / ENCARGADO')}

                            {/* Celda 6: Jefe de Turno */}
                            {renderFirma('JEFE_TURNO', 'FDO. JEFE TURNO')}
                        </tr>
                    </tbody>
                </table>

                {/* --- 3.1 TABLA: OT, EQUIPO E INCIDENCIA --- */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '10px' }}>
                    <tbody>
                        {/* Fila 1: OT y Equipo */}
                        <tr>
                            <td style={{ ...styles.thISO, width: '15%' }}>OT</td>
                            <td style={{ ...styles.td, width: '15%', fontWeight: 'bold' }}>{hpt.ot_referencia}</td>
                            <td style={{ ...styles.thISO, width: '20%' }}>DESCRIPCIÓN EQUIPO</td>
                            <td style={{ ...styles.td, width: '50%', fontWeight: 'bold' }}>
                                {hpt.codigo_activo} - {hpt.den_act_descripcion}
                            </td>
                        </tr>
                        
                        {/* Fila 2: PTs e Incidencia */}
                        <tr>
                            <td style={styles.thISO}>PTs</td>
                            <td style={{ ...styles.td, fontWeight: 'bold', color: hpt.numero_ptw ? '#d32f2f' : '#999' }}>
                                {hpt.numero_ptw || 'Pendiente'}
                            </td>
                            <td style={styles.thISO}>DESCRIPCIÓN INCIDENCIA</td>
                            <td style={{ ...styles.td, fontWeight: 'bold' }}>{hpt.titulo || '-'}</td>
                        </tr>
                    </tbody>
                </table>

                {/* --- 3.2 TABLA: DESCRIPCIÓN, FECHAS Y LOCALIZACIÓN --- */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '20px' }}>
                    <tbody>
                        {/* Fila 1: Título Descripción y Fecha */}
                        <tr>
                            <td colSpan="2" rowSpan="3" style={{ ...styles.thISO, width: '50%', textAlign: 'center' }}>DESCRIPCIÓN DEL TRABAJO</td>
                            <td style={{ ...styles.thISO, width: '25%' }}>FECHA PREVISTA</td>
                            <td style={{ ...styles.td, width: '25%', textAlign: 'center', fontWeight: 'bold' }}>{hpt.fecha_prevista}</td>
                        </tr>

                        {/* Fila 2: Texto Descripción y Horario */}
                        <tr>
                            <td style={styles.thISO}>HORARIO</td>
                            <td style={{ ...styles.td, textAlign: 'center', fontWeight: 'bold' }}>{hpt.horario_previsto} | {hpt.dias_previstos} {hpt.dias_previstos > 1 ? "Días" : "Día"}</td>
                        </tr>

                        {/* Fila 3: Localización */}
                        <tr>
                            <td style={styles.thISO}>LOCALIZACIÓN</td>
                            <td style={{ ...styles.td, textAlign: 'center', fontWeight: 'bold' }}>{hpt.nombre_zona}</td>
                        </tr>
                        <tr>
                            <td  colSpan="4" style={{ ...styles.td, width: '100%', backgroundColor: '#fff', fontWeight: 'bold', textAlign: 'center' }}>
                                {hpt.descripcion_trabajo}
                            </td>
                        </tr>
                        <tr>
                            <td  colSpan="4" style={{ ...styles.td, width: '100%', backgroundColor: '#fff', fontWeight: 'bold', textAlign: 'center' }}>
                                {hpt.preventivos_detallados && hpt.preventivos_detallados.length > 0 
                                    ? hpt.preventivos_detallados.map(p => p.nombre_recurso_preventivo).join(', ') 
                                    : ''}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* --- 3.4 TABLA: REPUESTOS Y MATERIALES --- */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '20px' }}>
                    <thead>
                        <tr>
                            <th colSpan="3" style={{ ...styles.thISO, textAlign: 'center' }}>REPUESTOS Y MATERIALES</th>
                        </tr>
                        <tr>
                            <th style={{ ...styles.thISO, width: '60%', textAlign: 'center' }}>DESCRIPCIÓN</th>
                            <th style={{ ...styles.thISO, width: '20%', textAlign: 'center' }}>UD.</th>
                            <th style={{ ...styles.thISO, width: '20%', textAlign: 'center' }}>ALMACÉN</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(() => {
                            const mats = hpt.materiales || [];
                            const rows = [];
                            const totalRows = Math.max(2, mats.length);
                            
                            for (let i = 0; i < totalRows; i++) {
                                const m = mats[i] || { descripcion: '', unidades: '', almacen: '' };
                                rows.push(
                                    <tr key={i}>
                                        <td style={styles.td}>{m.descripcion}</td>
                                        <td style={{ ...styles.td, textAlign: 'center' }}>{m.unidades}</td>
                                        <td style={{ ...styles.td, textAlign: 'center' }}>{m.almacen}</td>
                                    </tr>
                                );
                            }
                            return rows;
                        })()}
                    </tbody>
                </table>

                {/* --- 3.5 TABLA: ENERGÍAS DE TRABAJO, RECURSOS Y TRABAJOS PREVIOS --- */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '20px' }}>
                    <thead>
                        <tr>
                            <th colSpan="5" style={{ ...styles.thISO, textAlign: 'center' }}>
                                ENERGÍAS DE TRABAJO, RECURSOS Y TRABAJOS PREVIOS
                            </th>
                        </tr>
                        <tr>
                            <th style={{ ...styles.thISO, width: '20%', textAlign: 'center', fontSize: '9px' }}>EQUIPO ESPECIAL</th>
                            <th style={{ ...styles.thISO, width: '20%', textAlign: 'center', fontSize: '9px' }}>ACCESO</th>
                            <th style={{ ...styles.thISO, width: '20%', textAlign: 'center', fontSize: '9px' }}>ENERGÍA AL EQUIPO</th>
                            <th style={{ ...styles.thISO, width: '20%', textAlign: 'center', fontSize: '9px' }}>ENERGÍA DE TRABAJO</th>
                            <th style={{ ...styles.thISO, width: '20%', textAlign: 'center', fontSize: '9px' }}>TRABAJOS PREVIOS A REALIZAR</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {[
                                { key: 'EQUIPO ESPECIAL', items: ['Andamiero', 'Calorifugador', 'Soldador', 'ENDs', 'Mecanizado', 'Grup. Electrógeno', 'Compresor', 'Luminarias'] },
                                { key: 'ACCESO', items: ['Andamio / taller', 'Plataforma elevadora', 'Anticaídas Retráctiles', 'Línea de vida', 'Banqueta/alfombra', 'Escalera'] },
                                { key: 'ENERGÍA EQUIPO', items: ['HTF', 'Agua', 'Vapor', 'Químicos', 'Nitrógeno', 'Electrica', '75v CC/50v CA'] },
                                { key: 'ENERGÍA TRABAJO', items: ['Agua', 'N2', 'Argon', 'Aire', 'Electricidad', 'Gasolina/Gasoil'] },
                                { key: 'TRABAJOS PREVIOS', items: ['Enclavamiento eléctrico', 'Descargo eléctrico', 'Descargo mecánico', 'Comprobación NO arranque', 'Despresurizar', 'Drenar', 'PCI Fuera de Servicio', 'Inertizar (N2)', 'Levantamiento en pruebas'] }
                            ].map((col, idx) => (
                                <td key={idx} style={{ ...styles.td, verticalAlign: 'top', padding: '6px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                        {col.items.map((item, i) => {
                                            const recursoGuardado = hpt.recursos?.find(r => r.categoria === col.key && r.nombre_recurso === item && r.valor_check);
                                            const isChecked = !!recursoGuardado;
                                            
                                            return (
                                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '5px', fontSize: '9px' }}>
                                                    <div style={{ 
                                                        width: '10px', height: '10px', minWidth: '10px', 
                                                        border: '1px solid #003366', 
                                                        display: 'flex', justifyContent: 'center', alignItems: 'center', 
                                                        fontSize: '9px', fontWeight: 'bold', 
                                                        backgroundColor: isChecked ? '#e6f0fa' : '#fff',
                                                        color: '#003366'
                                                    }}>
                                                        {isChecked ? 'X' : ''}
                                                        
                                                    </div>
                                                    <span style={{ lineHeight: '1.2' }}>
                                                        {item}
                                                        {item === 'Químicos' && isChecked && recursoGuardado.detalle_texto && (
                                                            <span style={{ fontStyle: 'italic', color: '#555' }}>
                                                                {' '}({recursoGuardado.detalle_texto})
                                                            </span>
                                                        )}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>

                {/* --- 3.6 TABLA: COMENTARIOS DEL JEFE DE TURNO --- */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '20px' }}>
                    <tbody>
                        <tr>
                            <td style={{ ...styles.thISO, textAlign: 'center' }}>
                                COMENTARIOS DE LA REVISIÓN (Jefe Turno)
                            </td>
                        </tr>
                        <tr>
                            <td style={{ ...styles.td, height: '60px', verticalAlign: 'top', padding: '10px', backgroundColor: '#fff' }}>
                                {hpt.comentarios_jt || ''}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* --- SALTO DE PÁGINA SEGURO (Evita folios en blanco) --- */}
                <div className="html2pdf__page-break"></div>

                {/* --- 4. MATRIZ DE RIESGOS Y MEDIDAS (FORMATO COMPACTO 4 COLUMNAS) --- */}
                <div style={{ paddingTop: '10px' }}>
                    
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '5px' }}>
                        <tbody>
                            <tr>
                                <td style={{ ...styles.thISO, textAlign: 'center', fontSize: '10px', padding: '4px' }}>
                                    ANÁLISIS DE RIESGOS Y MEDIDAS PREVENTIVAS
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/*CONTENEDOR MULTICOLUMNA */}
                    <div style={{ 
                        columnCount:3, 
                        WebkitColumnCount: 4, 
                        MozColumnCount: 4, 
                        columnGap: '8px', 
                        width: '100%' 
                    }}>
                        {/* Sacamos las categorías y las pintamos */}
                        {[...new Set(catalogo.map(item => item.categoria))].map((cat, idx) => (
                            <div key={idx} style={{ 
                                breakInside: 'avoid', // Evita que una categoría se corte por la mitad entre dos columnas
                                pageBreakInside: 'avoid',
                                marginBottom: '6px', 
                                border: '1px solid #003366' 
                            }}>
                                
                                {/* Cabecera de la Categoría */}
                                <div style={{ 
                                    backgroundColor: '#003366', color: '#fff', 
                                    padding: '3px', fontSize: '7.5px', fontWeight: 'bold', 
                                    textTransform: 'uppercase', textAlign: 'center' 
                                }}>
                                    {idx + 1}. {cat}
                                </div>
                                
                                {/* Lista de Items (Riesgos y Medidas) */}
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {catalogo.filter(i => i.categoria === cat).map((item, i) => {
                                        const riesgoGuardado = hpt.riesgos_detallados?.find(r => r.id_item === item.id_item);
                                        const isChecked = !!riesgoGuardado; // Si lo encuentra, es true
                                        const esRiesgo = item.es_riesgo; 
                                        
                                        return (
                                            <div key={i} style={{ 
                                                display: 'flex', alignItems: 'flex-start', gap: '4px', 
                                                padding: '2px 4px', 
                                                fontSize: '6.5px', // Letra súper pequeña para que encaje 
                                                backgroundColor: esRiesgo ? '#d9d9d9' : '#ffffff', 
                                                borderBottom: '1px solid #ccc',
                                                color: '#000'
                                            }}>
                                                {/* Cajita del Checkbox */}
                                                <div style={{ 
                                                    width: '7px', height: '7px', minWidth: '7px', marginTop: '1px',
                                                    border: '1px solid #000', 
                                                    display: 'flex', justifyContent: 'center', alignItems: 'center', 
                                                    fontSize: '6px', fontWeight: 'bold',
                                                    backgroundColor: '#fff' 
                                                }}>
                                                    {isChecked ? 'X' : ''}
                                                </div>
                                                {/* Texto del ítem */}
                                                <span style={{ 
                                                    lineHeight: '1.1', 
                                                    fontWeight: esRiesgo ? 'bold' : 'normal' 
                                                }}>
                                                    {item.descripcion}
                                                    
                                                    {isChecked && riesgoGuardado.observacion_riesgo && (
                                                        <span style={{ fontWeight: 'normal', fontStyle: 'italic' }}>
                                                            {" -> " + riesgoGuardado.observacion_riesgo}
                                                        </span>
                                                    )}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* --- 5. DETALLE / OBSERVACIONES (CON FOTOS INCRUSTADAS) --- */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginTop: '15px' }}>
                    <tbody>
                        <tr>
                            <td style={{ ...styles.thISO, textAlign: 'center', fontSize: '10px', padding: '4px' }}>
                                DETALLE / OBSERVACIONES
                            </td>
                        </tr>
                        <tr>
                            <td style={{ ...styles.td, height: '210px', verticalAlign: 'top', padding: '8px', backgroundColor: '#fff' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'Center' }}>
                                    {hpt.imagenes && hpt.imagenes.length > 0 ? (
                                        hpt.imagenes.map((img, idx) => (
                                            <img 
                                                key={idx} 
                                                src={img} 
                                                alt={`Adjunto ${idx+1}`} 
                                                style={{ 
                                                    width: '35%',
                                                    height: '200px', 
                                                    objectFit: 'cover', 
                                                    border: '1px solid #003366', 
                                                    borderRadius: '3px' 
                                                }} 
                                            />
                                        ))
                                    ) : (
                                        <span style={{ color: '#999', fontStyle: 'italic', fontSize: '9px' }}>
                                            Sin observaciones ni fotografías adjuntas.
                                        </span>
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                </>
            )}

            {/* --- 6. TRABAJADORES Y HABILITACIONES (PÁGINAS FINALES) --- */}
            {opcionesPdf.trabajadores && hpt.trabajadores?.length > 0 && (() => {
                const workers = hpt.trabajadores || [];
                const totalSlots = Math.max(9, Math.ceil(workers.length / 9) * 9);
                const pages = [];

                for (let p = 0; p < totalSlots / 9; p++) {
                    const pageWorkers = [];
                    for (let i = 0; i < 9; i++) {
                        pageWorkers.push(workers[p * 9 + i] || null);
                    }
                    pages.push(pageWorkers);
                }

                const skillsList = [
                    { key: 'carretilla_elevadora', label: 'CARRETILLA ELEVADORA' },
                    { key: 'carretilla_telescopica', label: 'C. ELEV. TELESCÓPICA' },
                    { key: 'plataforma_elevadora', label: 'PLATAFORMA ELEVADORA' },
                    { key: 'puente_grua', label: 'PUENTE GRÚA' },
                    { key: 'espacios_confinados', label: 'ESPACIOS CONFINADOS' },
                    { key: 'baja_tension', label: 'BAJA TENSIÓN' },
                    { key: 'alta_tension', label: 'ALTA TENSIÓN' },
                    { key: 'recurso_preventivo', label: 'RECURSO PREVENTIVO' },
                    { key: 'camion_pluma', label: 'CAMIÓN PLUMA' },
                    { key: 'grua', label: 'GRÚA' }
                ];

                return pages.map((page, pageIdx) => (
                    <React.Fragment key={pageIdx}>
                        
                        {/* Salto de página por cada bloque de 9 trabajadores */}
                        <div className="html2pdf__page-break"></div>
                        
                        <div style={{ paddingTop: '10px' }}>
                            {/* Cabecera de la página */}
                            <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '15px' }}>
                                <tbody>
                                    <tr>
                                        <td style={{ ...styles.thISO, textAlign: 'center', fontSize: '11px' }}>
                                            RELACIÓN DE PERSONAL ASIGNADO Y HABILITACIONES (Pág. {pageIdx + 1})
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px' }}>
                                {page.map((worker, idx) => {
                                    const globalIdx = pageIdx * 9 + idx + 1;
                                    
                                    return (
                                        <table key={idx} style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #003366', fontSize: '8px' }}>
                                            <tbody>
                                                {/* Cabecera del Trabajador */}
                                                <tr>
                                                    <td colSpan="3" style={{ backgroundColor: '#e6f0fa', color: '#003366', border: '1px solid #003366', padding: '4px', fontWeight: 'bold', textAlign: 'center', fontSize: '9px' }}>
                                                        TRABAJADOR {globalIdx}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid #003366', padding: '3px', fontWeight: 'bold', width: '40%' }}>NOMBRE:</td>
                                                    <td colSpan="2" style={{ border: '1px solid #003366', padding: '3px', textTransform: 'uppercase' }}>
                                                        {worker ? worker.nombre : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid #003366', padding: '3px', fontWeight: 'bold' }}>APELLIDOS:</td>
                                                    <td colSpan="2" style={{ border: '1px solid #003366', padding: '3px', textTransform: 'uppercase' }}>
                                                        {worker ? worker.apellidos : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid #003366', padding: '3px', fontWeight: 'bold' }}>EMPRESA:</td>
                                                    <td colSpan="2" style={{ border: '1px solid #003366', padding: '3px', textTransform: 'uppercase' }}>
                                                        {worker ? worker.empresa : ''}
                                                    </td>
                                                </tr>
                                                
                                                {/* Mini Cabecera de SI/NO */}
                                                <tr>
                                                    <td style={{ border: '1px solid #003366', padding: '3px', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#f5f5f5' }}>HABILITACIÓN</td>
                                                    <td style={{ border: '1px solid #003366', padding: '3px', fontWeight: 'bold', textAlign: 'center', width: '15%', backgroundColor: '#f5f5f5' }}>SÍ</td>
                                                    <td style={{ border: '1px solid #003366', padding: '3px', fontWeight: 'bold', textAlign: 'center', width: '15%', backgroundColor: '#f5f5f5' }}>NO</td>
                                                </tr>

                                                {/* Fila por cada habilidad */}
                                                {skillsList.map((skill, sIdx) => (
                                                    <tr key={sIdx}>
                                                        <td style={{ border: '1px solid #003366', padding: '2px 4px' }}>{skill.label}</td>
                                                        <td style={{ border: '1px solid #003366', padding: '2px 4px', textAlign: 'center', fontWeight: 'bold', color: '#003366', fontSize: '9px' }}>
                                                            {worker ? (worker[skill.key] ? 'X' : '') : ''}
                                                        </td>
                                                        <td style={{ border: '1px solid #003366', padding: '2px 4px', textAlign: 'center', fontWeight: 'bold', color: '#003366', fontSize: '9px' }}>
                                                            {worker ? (!worker[skill.key] ? 'X' : '') : ''}
                                                        </td>
                                                    </tr>
                                                ))}

                                                {/* Fila final para otros certificados */}
                                                <tr>
                                                    <td style={{ border: '1px solid #003366', padding: '3px', fontWeight: 'bold' }}>OTROS:</td>
                                                    <td colSpan="2" style={{ border: '1px solid #003366', padding: '3px' }}>
                                                        {worker ? worker.otros : ''}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    );
                                })}
                            </div>
                        </div>
                    </React.Fragment>
                ));
            })()}

            {/* 7. ANEXO DE ESCALERA (SI EXISTE) */}
            {opcionesPdf.escalera && hpt.anexo_escalera && (
                <>  
                    <div className="html2pdf__page-break"></div>
                    
                    <div style={{ paddingTop: '15px' }}>
                        <PermisoEscalera 
                            datosPrevios={hpt.anexo_escalera} 
                            readOnly={true} 
                            isPdfMode={true} 
                        />
                    </div>
                </>
            )}

            {/* 8. ANEXO DE Plataforma Elevadora (SI EXISTE) */}
            {opcionesPdf.plataforma && hpt.anexo_plataforma && (
                <>
                    <div className="html2pdf__page-break"></div>
                    
                    <div style={{ paddingTop: '5px' }}>
                        <PermisoPlataforma 
                            datosPrevios={hpt.anexo_plataforma} 
                            readOnly={true} 
                            isPdfMode={true} 
                        />
                    </div>
                </>
            )}

            {/* 9. HOJAS DE CONSIGNACIÓN LOTO A4 (BLOQUEO Y DESCARGO) */}
            {opcionesPdf.bloqueoA4 && hpt.bloqueos_electricos?.map((b, idx) => (
                <React.Fragment key={`ba4-${idx}`}>
                    <div className="html2pdf__page-break"></div>
                    <div style={{ paddingTop: '15px' }}>
                        <BloqueoElectrico bloqueo={b} hpt={hpt} isPdfMode={true} printSection="A4" />
                    </div>
                </React.Fragment>
            ))}

            {opcionesPdf.descargoA4 && hpt.descargos_electricos?.map((d, idx) => (
                <React.Fragment key={`da4-${idx}`}>
                    <div className="html2pdf__page-break"></div>
                    <div style={{ paddingTop: '15px' }}>
                        <DescargoElectrico descargo={d} hpt={hpt} isPdfMode={true} printSection="A4" />
                    </div>
                </React.Fragment>
            ))}

            {/* 10. TARJETAS FÍSICAS A5 (FRONTAL Y REVERSO) */}
            {opcionesPdf.bloqueoA5 && hpt.bloqueos_electricos?.map((b, idx) => (
                <React.Fragment key={`ba5-${idx}`}>
                    <div className="html2pdf__page-break"></div>
                    <div style={{ paddingTop: '15px' }}>
                        <BloqueoElectrico bloqueo={b} hpt={hpt} isPdfMode={true} printSection="A5" />
                    </div>
                </React.Fragment>
            ))}

            {opcionesPdf.descargoA5 && hpt.descargos_electricos?.map((d, idx) => (
                <React.Fragment key={`da5-${idx}`}>
                    <div className="html2pdf__page-break"></div>
                    <div style={{ paddingTop: '15px' }}>
                        <DescargoElectrico descargo={d} hpt={hpt} isPdfMode={true} printSection="A5" />
                    </div>
                </React.Fragment>
            ))}
            
        </div>
    );
});

const styles = {
    page: { padding: '20px', fontFamily: 'Arial, sans-serif', color: '#000', backgroundColor: '#fff', fontSize: '11px' },
    thISO: { border: '1px solid #003366', padding: '6px', backgroundColor: '#d9d9d9', color: '#003366', fontWeight: 'bold', fontSize: '10px' },
    td: { border: '1px solid #003366', padding: '6px', fontSize: '11px', backgroundColor: '#fff' },
    sectionTitle: { borderBottom: '2px solid #003366', color: '#003366', marginTop: '20px', marginBottom: '10px', fontSize: '12px', fontWeight: 'bold' },
};  

export default HptPdfTemplate;